import { phoneModalTypes as Type } from '../../types/phone-modal';

export function setPhoneModalDismissed() {
  return {
    type: Type.SET_PHONE_MODAL_DISMISSED,
  };
}

export function resetPhoneModal() {
  return {
    type: Type.RESET_PHONE_MODAL,
  };
}

export function ensurePhonePrompt(userId: string) {
  return {
    type: Type.PHONE_PROMPT_ENSURE,
    userId,
  };
}

export function phonePromptFetchSuccess(payload: {
  userId: string;
  has_seen_phone_prompt: boolean;
}) {
  return {
    type: Type.PHONE_PROMPT_FETCH_SUCCESS,
    payload,
  };
}

